export function chromeAction(): boolean {
  return typeof chrome !== 'undefined' && chrome.action !== undefined
}

export function chromeCookies(): boolean {
  return typeof chrome !== 'undefined' && chrome.cookies !== undefined
}

export function chromeRuntime(): boolean {
  return typeof chrome !== 'undefined' && chrome.runtime !== undefined
}

export function chromeStorage(): boolean {
  return (
    typeof chrome !== 'undefined' &&
    chrome.storage?.local !== undefined &&
    chrome.storage?.onChanged !== undefined
  )
}

export function chromeTabs(): boolean {
  return typeof chrome !== 'undefined' && chrome.tabs !== undefined
}

export function chromeWindows(): boolean {
  return typeof chrome !== 'undefined' && chrome.windows !== undefined
}

export function chromeBackground(): boolean {
  return chromeRuntime() && typeof document === 'undefined'
}
